import { Integration_Service_Names_Enum } from '@main/graphql/types.admin.generated';

import { IntegrationService } from '../../../../lib';
import { AwsConnector } from '../../connector';

export const InspectorService = IntegrationService.make({
  connector: AwsConnector,
  name: Integration_Service_Names_Enum.Inspector,
});
